module.exports = __webpack_public_path__ + "a9d05da3f74d24146d45548440a4479f.woff";


/*****************
 ** WEBPACK FOOTER
 ** ./src/font/OpenSans-Light.woff
 ** module id = 1226
 ** module chunks = 9
 **/